// Content shared by the LaunchPad components (home and category landing pages)
// and scripts/inline-static-hero.js, which paints the same hero from
// index.html before the bundle loads. Keeping it here is what stops the two
// from drifting apart.

export const LAUNCHPAD_BASE_URL = 'https://assets.askhippo.co.za/LaunchPad/';
export const ICON_BASE_URL = 'https://assets.askhippo.co.za/LaunchPad/Icons/';

// Desktop LaunchPad image per route.
export const launchPadImageConfig = {
  '/funeral-insurance-quote': {
    file: 'LaunchPadFuneral.svg',
    width: 551,
    height: 551,
  },
  '/life-insurance-quote': {
    file: 'LaunchPadLife.svg',
    width: 551,
    height: 551,
  },
  '/medical-gap-cover-quote': {
    file: 'LaunchPadGapCover.svg',
    width: 551,
    height: 551,
  },
  '/medical-insurance-quotes': {
    file: 'LaunchPadMedicalInsurance.svg',
    width: 551,
    height: 551,
  },
  '/medical-aid-quote': {
    file: 'LaunchPadMedicalAid.svg',
    width: 551,
    height: 551,
  },
  '/pet-insurance-quote': {
    file: 'LaunchPadPetInsurance.svg',
    width: 551,
    height: 551,
  },
  '/travel-insurance': {
    file: 'LaunchPadTravel.svg',
    width: 551,
    height: 551,
  },
  '/motor-warranty': {
    file: 'LaunchPadMotorWarranty.svg',
    width: 551,
    height: 551,
  },
  '/dents-and-scratches-quote': {
    file: 'LaunchPadScratchAndDent.svg',
    width: 551,
    height: 551,
  },
  '/tyre-and-rim-guard': {
    file: 'LaunchPadTyreAndRim.svg',
    width: 551,
    height: 551,
  },
  '/vehicle-tracking-quote': {
    file: 'LaunchPadVehicleTracking.svg',
    width: 551,
    height: 551,
  },
  '/service-plan-quotes': {
    file: 'LaunchPadServicePlan.svg',
    width: 551,
    height: 551,
  },
  '/buildings-insurance-quote': {
    file: 'LaunchPadBuildingInsurance.svg',
    width: 551,
    height: 551,
  },
  '/business-insurance-quote': {
    file: 'LaunchPadBusiness.svg',
    width: 551,
    height: 551,
  },
  '/compare-fibre-deals': {
    file: 'LaunchPadFibre.svg',
    width: 551,
    height: 551,
  },
  '/car-insurance-quote': {
    // file: 'LaunchPadCarInsuranceNew.svg',
    file: 'LaunchPadCarInsuranceV2.svg',
    width: 551,
    height: 551,
  },
  '/motorcycle-insurance-quote': {
    file: 'LaunchPadMotorCycle.svg',
    width: 551,
    height: 551,
  },
  '/home-insurance-quote': {
    file: 'LaunchPadHomeContents.svg',
    width: 551,
    height: 551,
  },
  '/online-insurance-quote': {
    file: 'LaunchPadComboInsurance.svg',
    width: 551,
    height: 551,
  },
  '/personal-loans': {
    file: 'LaunchPadPersonalLoans.svg',
    width: 551,
    height: 551,
  },
  '/debt-counselling': {
    file: 'LaunchPadDebtCounselling.svg',
    width: 551,
    height: 551,
  },
  '/debt-consolidation-loans': {
    file: 'LaunchPadDebtConsolidation.svg',
    width: 551,
    height: 551,
  },
  '/business-insurance-quote/car-and-commercial-property-insurance': {
    file: 'LaunchPadVehicleCommercial.svg',
    width: 551,
    height: 551,
  },
  '/employee-benefits-quote': {
    file: 'LaunchPadEmployeeBenefits.svg',
    width: 551,
    height: 551,
  },
  '/business-insurance-quote/business-legal-cover': {
    file: 'LaunchPadBusinessLegalCover.svg',
    width: 551,
    height: 551,
  },
  '/business-insurance-quote/professional-liability-insurance-cover': {
    file: 'LaunchPadProfessionalLiability.svg',
    width: 551,
    height: 551,
  },
  '/': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  '/insurance': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  '/motor': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  '/health': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  '/money': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  '/internet': {
    file: 'LaunchPadHome.svg',
    width: 635,
    height: 635,
  },
  default: {
    file: 'LaunchPadDefault.svg',
    width: 551,
    height: 540,
  },
};

// Mobile-specific LaunchPad image config (328x314 as per the old JSX).
export const launchPadMobileImageConfig = {
  '/funeral-insurance-quote': {
    file: 'LaunchPadFuneral.svg',
    width: 328,
    height: 314,
  },
  '/life-insurance-quote': {
    file: 'LaunchPadLife.svg',
    width: 328,
    height: 314,
  },
  '/medical-gap-cover-quote': {
    file: 'LaunchPadGapCover.svg',
    width: 328,
    height: 314,
  },
  '/medical-insurance-quotes': {
    file: 'LaunchPadMedicalInsurance.svg',
    width: 328,
    height: 314,
  },
  '/medical-aid-quote': {
    file: 'LaunchPadMedicalAid.svg',
    width: 328,
    height: 314,
  },
  '/pet-insurance-quote': {
    file: 'LaunchPadPetInsurance.svg',
    width: 328,
    height: 314,
  },
  '/travel-insurance': {
    file: 'LaunchPadTravel.svg',
    width: 328,
    height: 314,
  },
  '/motor-warranty': {
    file: 'LaunchPadMotorWarranty.svg',
    width: 328,
    height: 314,
  },
  '/dents-and-scratches-quote': {
    file: 'LaunchPadScratchAndDent.svg',
    width: 328,
    height: 314,
  },
  '/tyre-and-rim-guard': {
    file: 'LaunchPadTyreAndRim.svg',
    width: 328,
    height: 314,
  },
  '/vehicle-tracking-quote': {
    file: 'LaunchPadVehicleTracking.svg',
    width: 328,
    height: 314,
  },
  '/service-plan-quotes': {
    file: 'LaunchPadServicePlan.svg',
    width: 328,
    height: 314,
  },
  '/buildings-insurance-quote': {
    file: 'LaunchPadBuildingInsurance.svg',
    width: 328,
    height: 314,
  },
  '/debt-counselling': {
    file: 'LaunchPadDebtCounselling.svg',
    width: 328,
    height: 314,
  },
  '/debt-consolidation-loans': {
    file: 'LaunchPadDebtConsolidation.svg',
    width: 328,
    height: 314,
  },
  '/business-insurance-quote/car-and-commercial-property-insurance': {
    file: 'LaunchPadVehicleCommercial.svg',
    width: 328,
    height: 314,
  },
  '/business-insurance-quote': {
    file: 'LaunchPadBusiness.svg',
    width: 328,
    height: 314,
  },
  '/compare-fibre-deals': {
    file: 'LaunchPadFibre.svg',
    width: 328,
    height: 314,
  },
  '/motorcycle-insurance-quote': {
    file: 'LaunchPadMotorCycle.svg',
    width: 328,
    height: 314,
  },
  '/home-insurance-quote': {
    file: 'LaunchPadHomeContents.svg',
    width: 328,
    height: 314,
  },
  '/online-insurance-quote': {
    file: 'LaunchPadComboInsurance.svg',
    width: 328,
    height: 314,
  },
  '/personal-loans': {
    file: 'LaunchPadPersonalLoans.svg',
    width: 328,
    height: 314,
  },
  '/car-insurance-quote': {
    //  file: 'LaunchPadCarInsuranceNew.svg',
    file: 'LaunchPadCarInsuranceV2.svg',
    width: 328,
    height: 314,
  },
  '/employee-benefits-quote': {
    file: 'LaunchPadEmployeeBenefits.svg',
    width: 328,
    height: 314,
  },
  '/business-insurance-quote/business-legal-cover': {
    file: 'LaunchPadBusinessLegalCover.svg',
    width: 328,
    height: 314,
  },
  '/business-insurance-quote/professional-liability-insurance-cover': {
    file: 'LaunchPadProfessionalLiability.svg',
    width: 328,
    height: 314,
  },
  '/': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  '/insurance': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  '/motor': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  '/health': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  '/money': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  '/internet': {
    file: 'LaunchPadHome.svg',
    width: 328,
    height: 314,
  },
  default: {
    file: 'LaunchPadDefault.svg',
    width: 328,
    height: 314,
  },
};

// Icon file (under ICON_BASE_URL) for each category in the icon row.
export const CATEGORY_ICON_NAMES = {
  Motor: 'car',
  Health: 'medical-bag',
  Life: 'family',
  Money: 'Money',
  Business: 'ShieldHeart',
  Internet: 'Wifi',
};

export const CATEGORY_LABELS = {
  Motor: 'Motor',
  Health: 'Health',
  Life: 'Life',
  Money: 'Money',
  Business: 'Business',
  Internet: 'Internet',
};

// Home and the category landing pages: the LaunchPad with the category icon
// row, product dropdown and a custom header.
export const HOME_STYLE_LAUNCH_PADS = {
  '/': {
    header: 'Dunno if you can find better?',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Car Insurance',
    activeIcon: 'Motor',
  },
  '/insurance': {
    header: 'Compare insurance with Hippo',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Car Insurance',
    activeIcon: 'Motor',
  },
  '/motor': {
    header: 'Compare all motor cover with Hippo',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Car Insurance',
    activeIcon: 'Motor',
  },
  '/health': {
    header: 'Compare healthcare products with Hippo',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Medical Aid',
    activeIcon: 'Health',
  },
  '/money': {
    header: 'Compare money solutions with Hippo',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Personal Loans',
    activeIcon: 'Money',
  },
  '/internet': {
    header: 'Compare internet providers with Hippo',
    byLine: 'Compare multiple quotes in just 2 minutes',
    button: 'Get quotes',
    selectedOption: 'Fibre Internet',
    activeIcon: 'Internet',
  },
};

export const HOME_STYLE_PATHS = Object.keys(HOME_STYLE_LAUNCH_PADS);

// Landing page each product in the dropdown leads to.
export const LAUNCH_PAD_PRODUCT_ROUTES = {
  'Motorbike Insurance': '/motorcycle-insurance-quote/',
  'Tyre & Rim Cover': '/tyre-and-rim-guard/',
  'Scratch & Dent Cover': '/dents-and-scratches-quote/',
  'Car Insurance': '/car-insurance-quote/',
  'Combo Insurance': '/online-insurance-quote/',
  'Motor Warranty': '/motor-warranty/',
  // 'Car Rental': '/CarRental/',
  'Service Plans': '/service-plan-quotes/',
  'Vehicle Tracking': '/vehicle-tracking-quote/',
  'Home Contents Cover': '/home-insurance-quote/',
  'Building Insurance': '/buildings-insurance-quote/',
  'Business Insurance': '/business-insurance-quote/',
  'Commercial Property Insurance':
    '/business-insurance-quote/car-and-commercial-property-insurance/',
  // 'Vehicle Insurance': '/VehicleInsurance/',
  'Business Legal Cover': '/business-insurance-quote/business-legal-cover/',
  'Professional Liability Insurance':
    '/business-insurance-quote/professional-liability-insurance-cover/',
  // 'Business Loans': '/BusinessLoans/',
  'Employee Benefits': '/employee-benefits-quote/',
  'Medical Insurance': '/medical-insurance-quotes/',
  'Medical Aid': '/medical-aid-quote/',
  'Gap Cover': '/medical-gap-cover-quote/',
  'Life Insurance': '/life-insurance-quote/',
  'Funeral Insurance': '/funeral-insurance-quote/',
  'Pet Insurance': '/pet-insurance-quote/',
  'Travel Insurance': '/travel-insurance/',
  'Personal Loans': '/personal-loans/',
  'Debt Counselling': '/debt-counselling/',
  'Debt Consolidation': '/debt-consolidation-loans/',
  'Fibre Internet': '/compare-fibre-deals/',
};

// Fibre's quote-flow steps live under a different base path than its
// landing page (/check-fibre-in-your-area vs /compare-fibre-deals); every
// other product shares the same base for both, so this only needs an
// entry when the two diverge.
export const LAUNCH_PAD_PRODUCT_STEP_ROUTES = {
  'Fibre Internet': '/check-fibre-in-your-area/',
};
